import { AttachmentPreviewRef } from "@cs_teamwaydev/mailvista-sdk_react";
import { getDownloadName, isImageType, isPdfType } from "./attachmentMime";

// Type d'affichage COMMUN aux deux variantes du panneau documents (thread ⇄ CustomView), cf. AB#1727.
// - THREAD      : la preview (data URL) est DÉJÀ chargée inline → `previewInline`.
// - CUSTOM_VIEW : pas de preview ; on porte `ref` (uniqueMailvistaId + attachmentId) pour la récupérer
//                 À LA DEMANDE via `mailManager.getAttachmentPreview(ref)` (resolver, cf. DocumentPreview).
// Un des deux (`previewInline` OU `ref`) doit être présent pour pouvoir prévisualiser / télécharger.
type DisplayAttachmentProps = {
    // Clé stable d'affichage + identité pour la navigation prev/next (findIndex).
    key: string;
    name: string;
    type: string;
    size: number;
    contentId?: string;
    sentAt?: Date;
    previewInline?: string;
    ref?: AttachmentPreviewRef;
};

export default class DisplayAttachment {
    key: string;

    name: string;

    type: string;

    size: number;

    contentId?: string;

    sentAt?: Date;

    previewInline?: string;

    ref?: AttachmentPreviewRef;

    constructor({
        key,
        name,
        type,
        size,
        contentId,
        sentAt,
        previewInline,
        ref,
    }: DisplayAttachmentProps) {
        this.key = key;
        this.name = name;
        this.type = type;
        this.size = size;
        this.contentId = contentId;
        this.sentAt = sentAt;
        this.previewInline = previewInline;
        this.ref = ref;
    }

    isImage() {
        return isImageType(this.type);
    }

    isPdf() {
        return isPdfType(this.type);
    }

    getDownloadName() {
        return getDownloadName(this.name, this.type);
    }
}
